module.exports = __webpack_public_path__ + "img/sp1.3b0b76a6.png";